import styled, { css, keyframes } from "styled-components";
const animateIncrease = keyframes`
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
`;
const animateDecrease = keyframes`
  0% {
    width: 100%;
  }
  100% {
    width: 0;
  }
`;
const ProgressAnimation = styled.div(
  ({ theme, $animationDuration, $increase }) => css`
    position: absolute;
    top: 0;
    bottom: 0;
    height: 2px;
    animation: linear ${$increase ? animateIncrease : animateDecrease} ${$animationDuration}ms;
    background-color: ${theme.colors.text.primary};
    z-index: 2;
    ${$increase ? "left: 0;" : "right: 0;"}
  `
);
export default ProgressAnimation;
